export default "__VITE_ASSET__BDQ1EeBP__"